import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "src/app/app.component";
import { CrudHttp } from "src/app/helpers/CrudHttp";
import { Utilerias } from "src/app/helpers/Utilerias";
import { BloqueConfiguracion } from "src/app/types/type";
import { ConfiguracionService } from "src/app/services/configuracion.service";
declare var $: any;

@Component({
  selector: "app-checklist-paso2",
  templateUrl: "./checklist-paso2.component.html",
  styleUrls: ["./checklist-paso2.component.css"],
})
export class ChecklistPaso2Component implements OnInit {
  idChecklist: number;
  idTipoRevision: number;
  title: string;
  item: object;
  bloques: BloqueConfiguracion[];
  bloqueEdit: any;
  subMenus: {
    active: boolean;
    child: boolean;
    label: string;
    router: string;
    class: string;
  }[];
  crudBloque: CrudHttp;
  crudRubro: CrudHttp;
  rubroEdit: any;
  ponderacionCheck: number;
  ponderacionRubro: number;
  ordenesBloque: any;
  countOrden: number;
  validBtnContinue = false;

  constructor(
    private configService: ConfiguracionService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private father: AppComponent
  ) {
    father.moduleName = "Configuracion";
    this.idChecklist = parseInt(this.activatedRoute.snapshot.params.id);
    this.idTipoRevision = parseInt(this.activatedRoute.snapshot.params.idrevision);
    this.title = "Checklist paso 2";
    this.crudBloque = new CrudHttp(http);
    this.crudBloque.methodGet = "GetBloquesChecklist?idChecklist=" + this.idChecklist;
    this.crudBloque.methodPost = "SetBloque";
    this.crudBloque.methodPut = "UpdateBloque";
    this.crudBloque.methodDelete = "DeleteBloque";

    this.crudRubro = new CrudHttp(http);
    this.crudRubro.methodGet = "GetRubros";
    this.crudRubro.methodPost = "SetRubro";
    this.crudRubro.methodPut = "UpdateRubro";
    this.crudRubro.methodDelete = "DeleteRubro";
    this.ponderacionCheck = 100;
    this.bloques = [];
    this.ordenesBloque = [];
    this.countOrden = 0;
    this.bloqueEdit = {
      Nombre: "",
      Ponderacion: null,
      Orden: null,
    };

    this.rubroEdit = {
      Nombre: "",
      Descripcion: "",
      Ponderacion: 100,
      Orden: 1,
    };
  }

  ngOnInit() {
    this.loadSubMenu();
    this.dataBind();

    $("#modalNewRubro").on("hidden.bs.modal", function () {
      Utilerias.ClearFields(
        "#NombreNewRubro|#DescripcionNewRubro|#OrdenNewRubro|#PonderacionNewRubro"
      );
    });
  }

  dataBind(edit = false) {
    this.configService.getBloquesChecklist(this.idChecklist)
      .subscribe(resp => {
        if (resp.Result.Exito) {
          this.bloques = resp.Result.Data as BloqueConfiguracion[];

          let sumPonderacion = 0;
          this.bloques.forEach(b => sumPonderacion += b.Ponderacion);

          if (edit) this.ponderacionCheck = 100;

          this.ponderacionCheck = this.ponderacionCheck - sumPonderacion;

          this.validBtnContinue = !this.validRubros();
        } else {
          Utilerias.alertClient('', resp.Result.Error, 0);
        }
      })
  }

  validRubros() {
    if (this.bloques.length === 0) return false;
    for (const bloque of this.bloques) {
      if (bloque.Rubros.length === 0) return false;
      let ponderacionRubros = 0
      for (const rubro of bloque.Rubros) {
        ponderacionRubros += rubro.Ponderacion
      }
      if (ponderacionRubros % 100 != 0) return false
    }
    return true;
  }

  editBloqueClick(item) {
    this.bloqueEdit = item;
    localStorage["IdBloqueEdit"] = item.IdBloque;
    $("#modalEdit").modal("show");
  }

  deleteBloqueClick(idBloque: number) {
    Utilerias.alertConfirm("Si realiza esta acción se eliminara todo el bloque y sus relaciones", '¿Deseas eliminar el bloque?')
      .then((res) => {
        if (res.value) {
          this.configService.deleteBloque(idBloque)
            .subscribe(resp => {
              if (resp.Result.Exito) {
                this.dataBind(true);
              } else
                Utilerias.alertClient('', resp.Result.Error, 0);
            })
          // this.crudBloque.delete({ idBloque: id }).then(() => {
          // });
        }
      });
  }

  newRubroClick(id) {
    localStorage["IdBloqueNewRubro"] = id;
    $("#modalNewRubro").modal("show");

    this.obtenerValorRubro(id);
  }

  editRubroClick(item) {
    this.rubroEdit = item;
    localStorage["IdRubroEdit"] = item.IdRubro;
    $("#modalEditRubro").modal("show");
  }

  deleteRubroClick(idBloque, id) {
    Utilerias.alertConfirm("¿Deseas eliminar el rubro?").then((res) => {
      if (res.value) {
        this.crudRubro.delete({ idRubro: id }).then(() => {
          let aux = this.bloques.find((x) => x.IdBloque == idBloque).Rubros;
          aux = aux.filter((x) => x.IdRubro != id);
          this.bloques.find((x) => x.IdBloque == idBloque).Rubros = aux;
          this.validBtnContinue = !this.validRubros();
        });
      }
    });
  }

  formNewBloque(e: Event) {
    e.preventDefault();
    let ponderacion = parseInt($("#Ponderacion").val());

    if (!this.isValidPonderacion(this.bloques, "Ponderacion", ponderacion)) {
      Utilerias.alertClient(
        null,
        "La suma de las ponderaciones no puede ser mayor a 100.",
        1
      );
      return;
    }
    this.ponderacionCheck = this.ponderacionCheck - ponderacion;
    let obj = {
      b: {
        IdChecklist: this.idChecklist,
        Nombre: $("#Nombre").val(),
        Ponderacion: $("#Ponderacion").val(),
        Orden: $("#Orden").val() == "" ? 0 : $("#Orden").val(),
      },
    };
    this.crudBloque.post(obj).then((res: any) => {
      res.Rubros = [];
      this.bloques.push(res);
      Utilerias.ClearFields("#Nombre|#Ponderacion");
      Utilerias.showLoader(false);
    });
  }

  formEditBloque(e: Event) {
    e.preventDefault();
    var id = parseInt(localStorage["IdBloqueEdit"]);
    let obj = {
      b: {
        IdBloque: id,
        Nombre: $("#NombreEdit").val(),
        Ponderacion: $("#PonderacionEdit").val(),
        Orden: $("#OrdenEdit").val(),
      },
    };
    this.crudBloque.put(obj).then((res: any) => {
      localStorage.removeItem("IdBloqueEdit");
      for (let item of this.bloques) {
        if (item.IdBloque == res.IdBloque) {
          item.Nombre = res.Nombre;
          item.Ponderacion = res.Ponderacion;
          item.Orden = res.Orden;
          break;
        }
      }
      $("#modalEdit").modal("hide");
      Utilerias.showLoader(false);
    });
  }

  formNewRubro(e: Event) {
    e.preventDefault();
    var id = parseInt(localStorage["IdBloqueNewRubro"]);
    let ponderacion = parseInt($("#PonderacionNewRubro").val());
    let bloqueRubro = this.bloques.find((x) => x.IdBloque == id);
    let ponderacionOcupada = parseInt(localStorage["ponderacionOcupada"]);
    let sumaPonderacion = ponderacionOcupada + ponderacion;
    if (sumaPonderacion > 0 && sumaPonderacion <= 100) {
      let obj = {
        r: {
          IdBloque: id,
          Nombre: $("#NombreNewRubro").val(),
          Descripcion: $("#DescripcionNewRubro").val(),
          Ponderacion: $("#PonderacionNewRubro").val(),
          Orden:
            $("#OrdenNewRubro").val() == "" ? 0 : $("#OrdenNewRubro").val(),
        },
      };
      this.crudRubro.post(obj).then((res: any) => {
        this.bloques.find((x) => x.IdBloque == res.IdBloque).Rubros.push(res);
        this.validBtnContinue = !this.validRubros();
        localStorage.removeItem("IdBloqueNewRubro");
        $("#modalNewRubro").modal("hide");
      });
    } else {
      let ponderacionDiponible = 100 - ponderacionOcupada;
      Utilerias.alertClient(
        null,
        "La suma de la ponderación de los rubros no debe ser mayor a 100, Ponderación disponible " +
        ponderacionDiponible,
        1
      );
      Utilerias.showLoader(false);
      return;
    }
    Utilerias.showLoader(false);
  }

  formEditRubro(e: Event) {
    e.preventDefault();
    var id = parseInt(localStorage["IdRubroEdit"]);
    let obj = {
      r: {
        IdRubro: id,
        Nombre: $("#NombreEditRubro").val(),
        Descripcion: $("#DescripcionEditRubro").val(),
        Ponderacion: $("#PonderacionEditRubro").val(),
        Orden: $("#OrdenEditRubro").val(),
      },
    };
    this.crudRubro.put(obj).then((res: any) => {
      localStorage.removeItem("IdRubroEdit");
      for (let item of this.bloques) {
        if (item.IdBloque == res.IdBloque) {
          for (let rubro of item.Rubros) {
            if (rubro.IdRubro == res.IdRubro) {
              rubro.Nombre = res.Nombre;
              rubro.Descripcion = res.Descripcion;
              rubro.Ponderacion = res.Ponderacion;
              rubro.Orden = res.Orden;
              break;
            }
          }
          break;
        }
      }

      $("#modalEditRubro").modal("hide");
      Utilerias.showLoader(false);
    });
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: "Paso 1",
        router: `../../../ChecklistPaso1/${this.idChecklist}/${this.idTipoRevision}`,
        class: "submenu__item d-flex align-items-center",
      },
      {
        active: true,
        child: false,
        label: "Paso 2",
        router: null,
        class: "submenu__item submenu--active d-flex align-items-center",
      },
    ];
    this.subMenus = items;
  }

  obtenerValorRubro(idBloque) {
    Utilerias.httpRequest(this.http, "ObtenerPonderacionRubro", "post", {
      Id_Bloque: idBloque,
    }).then((resp: any) => {
      this.ponderacionRubro = 100 - resp.Ponderacion;
      localStorage["ponderacionOcupada"] = resp.Ponderacion;
    });
  }

  isValidPonderacion(collection, key, request) {
    if (collection.length > 0) {
      let sum = collection.map((x) => x[key]).reduce((x, y) => x + y);
      return sum + request <= 100;
    } else {
      return true;
    }
  }

  isValidPonderacionRubro(bloque, collection, key, request) {
    if (collection.length === 0) {
      return request <= bloque.Ponderacion;
    } else if (collection.length > 0) {
      let sum = collection.map((x) => x[key]).reduce((x, y) => x + y);
      return sum + request <= bloque.Ponderacion;
    } else {
      return true;
    }
  }

  ValidaPonderacion(event: any) {
    let valor = event.target.value;

    if (parseInt(valor) > 100) {
      Utilerias.alertClient('Ponderación', 'El valor de la ponderación no debe ser mayor a 100', 0);
    }
    if (valor.length >= 3) {

      return false;
    }
    return true;
  }

  shoModalOrden() {
    $("#modalEditOrdenBloque").modal('show');

    let clase = $(".clsOrden").val('');
    $(".clsOrden").text('');

    this.ordenesBloque = [];
  }

  agregandoOrden(Idcheck, idbloque, nombreBloque) {
    let ordenTxt = $(`#${nombreBloque}${idbloque}`).val();

    let item = this.ordenesBloque.find(x => x.Orden === ordenTxt);
    console.log('El item buscado ', item);
    console.log('contenido del arreglo ', this.ordenesBloque);
    if (item != null && item != undefined) {
      Utilerias.alertClient('Error', 'ya se encuentra otro bloque con este orden, "' + item.Orden + '"555555555555', 0);
      return false;
    }

    if (ordenTxt <= (this.bloques.length) && this.countOrden <= (this.bloques.length)) {
      let obj = {
        IdChecklist: Idcheck,
        IdBloque: idbloque,
        Orden: ordenTxt
      }
      this.ordenesBloque.push(obj);
      this.countOrden = this.countOrden + 1;
    }
    else {
      Utilerias.alertClient('Error', 'El número del orden no puede ser más grande que el número de bloques', 0);
      return false;
    }


  }

  saveOrdenBloque() {
    console.log('tamaño ', (this.ordenesBloque.length - this.bloques.length));
    if (this.ordenesBloque.length < this.bloques.length) {

      Utilerias.alertClient('Error', 'Falta por asignar ' + (this.bloques.length - this.ordenesBloque.length) + ' Bloques', 0);
      return false;
    }
    if (this.ordenesBloque.length > 0) {

      Utilerias.showLoader(true);
      Utilerias.httpRequest(this.http, 'UpdateOrdenBloque', 'post', { Ordenamiento: this.ordenesBloque })
        .then(resp => {
          $("#modalEditOrdenBloque").modal('hide');
          console.log('la respuesta ', resp);
          this.dataBind(true);
          Utilerias.showLoader(false);
          //window.location.reload();
        })
    }
    else {
      Utilerias.alertClient('Error', 'No hay nuevo ordenamiento de bloques', 0);
    }
  }

  redirectPaso3() {
    this.router.navigate([`Configuracion/ChecklistPaso3/${this.idChecklist}/${this.idTipoRevision}`]);
  }
}
